// extracted by mini-css-extract-plugin
export var labelWrapper = "_ga-0";